import Link from "next/link";
import { useRouter } from "next/router";
import * as React from "react";
import { ScheduleList } from "@components/ShopDetail";
import { paths } from "@libs/paths";
import { IFImg } from "@libs/utils/IFImg";
import { GTMEvent, GTMEvents } from "@libs/utils/gtm";
import styles from "./index.module.css";
import type { ShopDetailSchedule_ShopFragment } from "./__generated__/fragments";

type Props = {
  shop: ShopDetailSchedule_ShopFragment;
  isColumn?: boolean;
};

const Schedule: React.FC<Props> = ({ shop, isColumn = false }) => {
  const { asPath } = useRouter();
  const fullPath = process.env.APP_HOST + asPath;

  const leadToAppLinkTexts = shop.canReserveOnSystemPayment
    ? [
        `ネット予約&事前決済で最大${shop.maxPossiblePoints}ptもらえる！`,
        "アプリなら還元率UP！",
      ]
    : [
        `ネット予約で最大${shop.maxPossiblePoints}pt（来店人数×25pt）`,
        "もらえる！アプリなら来店人数×50pt！",
      ];

  const handleToReservationFormClick = () => {
    GTMEvent(
      GTMEvents.toReservationFormPressed("他の日にちで予約する", shop.uuid)
    );
  };

  return (
    <>
      {(isColumn || shop.isReservationActive) && (
        <div className={(!isColumn && "md:none") || undefined}>
          <div className={styles.schedule}>
            <h1
              className={
                isColumn
                  ? `${styles.scheduleTitleCol} c-contentTitle`
                  : `${styles.scheduleTitle} c-contentTitle`
              }
            >
              予約スケジュール
            </h1>

            {shop.isReservableOnline && (
              <div className={styles.pointLink}>
                <i className={styles.pointIcon}>
                  <img src={IFImg("/img/icon_fansta_point_white.svg")} />
                </i>
                <a href={paths.appOneLinkForShop(fullPath)} target="_blank">
                  {leadToAppLinkTexts.map((text, idx) => (
                    <p key={idx}>{text}</p>
                  ))}
                </a>
              </div>
            )}

            <div className={styles.calendar}>
              <ScheduleList shop={shop} />
            </div>

            {shop.isReservableOnline && (
              <div className={styles.link}>
                <Link
                  href={paths.shopRequestReservation(shop.uuid)}
                  onClick={handleToReservationFormClick}
                >
                  他の日にちで予約する
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Schedule;
